import { Blockchain } from "@rarible/api-client"
import { toCurrencyId } from "../../../price/types"
import { FEE_CONFIG_URL } from "../constants"
import type { StaticEthereumBlockchainConfig } from "../types"

export const basecampConfig: StaticEthereumBlockchainConfig = {
  name: "Camp",
  icon: "/images/blockchains/base-camp.svg",
  isEvm: true,
  testnet: false,
  isTestnet: false,
  feesVersion: "v3",
  treasury: "0x64d34BcfC32Fb663172C47d6E4Fb1dBFaba6e7a2",
  unionApi: "https://api.rarible.org",
  basePath: "https://camp-api.rarible.org",
  chainId: 484,
  blockchain: Blockchain.CAMP,
  chainName: "Camp",
  exchange: {
    v2: "0xb968fbA0d911e474c405cf6F375582d7b5C8cEE3",
    wrapper: "0x52e45bc6D0E22bbd42Db1B91299cAEED367b9afe",
  },
  blockExplorers: [
    {
      url: "https://camp.cloud.blockscout.com",
      icon: "/images/scanner.svg",
      adress: "https://camp.cloud.blockscout.com/address/${adrress}",
    },
  ],
  rpcUrls: [],
  privateRpcNodeSlug: "camp-node",
  transferProxies: {
    nft: "0x147d06FbDA085C0455615E554D87262B0726ad0c",
    erc721Lazy: "0xA76790d72b3120F530EDb7259271c4F369894c76",
    erc20: "0x5C938272c3305f40691B584E1243c30118640cCB",
  },
  feeConfigUrl: FEE_CONFIG_URL,
  primaryCurrency: {
    id: toCurrencyId("CAMP:0x0000000000000000000000000000000000000000"),
    symbol: "camp",
    name: "Camp",
    decimals: 18,
  },
  wrappedCurrency: {
    id: toCurrencyId("CAMP:0x3bd5c81a8adf3355078dc5f73c41d3194b316690"),
    symbol: "wcamp",
    name: "Wrapped Camp",
    decimals: 18,
  },
  addFundsLink: "",
  hasStabilityProtocol: true,
  viem: {
    id: 484,
    name: "Camp",
    nativeCurrency: {
      decimals: 18,
      name: "Camp",
      symbol: "CAMP",
    },
    rpcUrls: {
      default: { http: ["https://rpc.camp.raas.gelato.cloud"] },
    },
    blockExplorers: {
      default: {
        name: "Basecamp Explorer",
        url: "https://camp.cloud.blockscout.com",
      },
    },
    testnet: false,
  },
}

export const getBaseCampConfig = (): StaticEthereumBlockchainConfig =>
  basecampConfig
